enum TabletalkProgramStatus {
  CONFIGURATION = "CONFIGURATION",
  PARTICIPANT_REVIEW = "PARTICIPANT_REVIEW",
  PARTICIPANT_APPLICATION = "PARTICIPANT_APPLICATION",
  PARTICIPANT_APPLICATION_REVIEW = "PARTICIPANT_APPLICATION_REVIEW",
  INITIAL_SYSTEM_MATCHING = "INITIAL_SYSTEM_MATCHING",
  ACCEPT_MEETINGS = "ACCEPT_MEETINGS",
  FINAL_SYSTEM_MATCHING = "FINAL_SYSTEM_MATCHING",
  FINAL_INVITES = "FINAL_INVITES",
  IN_PROGRESS = "IN_PROGRESS",
  RECONCILIATION = "RECONCILIATION",
  FEEDBACK = "FEEDBACK",
  COMPLETED = "COMPLETED"
}

export default TabletalkProgramStatus;
